export const logPageStasticsTypes =
{
  'circulation': {
    type: '流通券幣',
    subTypeKeys: [
      {
        subType: '鈔券',
        keys: ['banknote', 'anniversary', 'picture-guide']
      },
      {
        subType: '硬幣',
        keys: ['currency', 'anniversary-currency']
      }
    ]
  },
  'anti-counterfeit': {
    type: '新臺幣防偽功能',
    subTypeKeys: [
      {
        subType: '流通券幣防偽',
        keys: ['circulation']
      },
      {
        subType: '流通鈔券',
        keys: ['note']
      },
      {
        subType: '流通硬幣',
        keys: ['coin']
      },
      {
        subType: '舊版新臺幣',
        keys: ['old-version']
      }
    ]
  },
  'commemorate': {
    type: '套幣與紀念性券幣',
    subTypeKeys: [
      {
        subType: '生肖系列',
        keys: ['zodiac-sign-first', 'zodiac-sign-second', 'zodiac-sign-third']
      },
      {
        subType: '主題套幣',
        keys: ['theme-national-park', 'theme-aboriginal', 'theme-flower', 'theme-other']
      },
      {
        subType: '紀念鈔券',
        keys: ['note']
      },
      {
        subType: '紀念幣',
        keys: ['coin-national-celebration', 'coin-festival', 'coin-international-events', 'coin-special-memorial']
      },
      {
        subType: '紀念章',
        keys: ['medal-national-celebration', 'medal-festival']
      }
    ]
  },
  'cycle': {
    type: '券幣的生命週期',
    subTypeKeys: [
      {
        subType: '券幣的一生',
        keys: ['lifetime', 'lifetime-design', 'lifetime-print-cast', 'lifetime-issue', 'lifetime-arrange', 'lifetime-destroy']
      },
      {
        subType: '鈔票印製',
        keys: ['print-plant', 'print-step']
      },
      {
        subType: '硬幣鑄造',
        keys: ['cast-plant', 'cast-step']
      },
      {
        subType: '愛惜鈔券',
        keys: ['cherish']
      }
    ]
  },
  'story': {
    type: '貨幣的故事',
    subTypeKeys: [
      {
        subType: '什麼是貨幣',
        keys: ['what-is-currency']
      },
      {
        subType: '貨幣的誕生與演進',
        keys: ['birth']
      },
      {
        subType: '券幣萬花筒',
        keys: ['kaleidoscope']
      },
      {
        subType: '券幣達人',
        keys: ['master']
      },
      {
        subType: '貨幣的演進',
        keys: ['evolution']
      }
    ]
  },
  'history': {
    type: '我國券幣的歷史',
    subTypeKeys: [
      {
        subType: '臺灣貨幣的發展',
        keys: ['develop']
      },
      {
        subType: '券幣歷史介紹',
        keys: ['introduce']
      }
    ]
  },
  'service': {
    type: '首頁',
    fixSubType: '訊息與服務',
    subTypeKeys: [
      {
        subType: '訊息與服務',
        keys: ['announcement', 'promote', 'audio', 'law', 'link']
      }
    ]
  },
  'multimedia': {
    type: '首頁',
    fixSubType: '多媒體專區',
    subTypeKeys: [
      {
        subType: '多媒體專區',
        keys: ['download', 'game', 'video']
      }
    ]
  },
  'communicate': {
    type: '首頁',
    fixSubType: '交流園地',
    subTypeKeys: [
      {
        subType: '交流園地',
        keys: ['email', 'faq']
      }
    ]
  },
  'sitemap': {
    type: '首頁',
    fixSubType: '網站導覽',
    subTypeKeys: [
      {
        subType: '網站導覽',
        keys: ['sitemap']
      }
    ]
  },
  'announcement': {
    type: '首頁',
    subTypeKeys: [
      {
        subType: '關於券幣數位博物館',
        keys: ['about-museum']
      },
      {
        subType: '政府網站開放資料宣告',
        keys: ['about-museum']
      },
      {
        subType: '著作權聲明',
        keys: ['copyright']
      },
      {
        subType: '隱私權宣告',
        keys: ['privacy']
      },
      {
        subType: '資訊安全政策宣告',
        keys: ['security']
      }
    ]
  }
};